var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Spacing, Text } from '@doordash/design-language';
import Button from '@doordash/component-button';
import * as React from 'react';
import styled from 'styled-components';
import { IMAGE_BASE_URL } from '../constants/values';
import { PageNotFoundTestId } from './testId';
import { PortalWrapper, BaseContainer, BackgroundWrapper, } from './Styles/Containers';
var CONTENT_MAX_WIDTH = 480;
export var ImgContainer = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  margin: ", "px auto;\n"], ["\n  width: 100%;\n  margin: ", "px auto;\n"])), Spacing.Large);
export var Container = styled(BaseContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", "px 0;\n  max-width: ", "px;\n"], ["\n  padding: ", "px 0;\n  max-width: ", "px;\n"])), 2 * Spacing.XxLarge, CONTENT_MAX_WIDTH);
var PageNotFound = function (_a) {
    var _b = _a.errorMessage, errorMessage = _b === void 0 ? 'Oops, we donut know which page you’re looking for.' : _b;
    var handleClick = function () {
        if (window) {
            window.history.back();
        }
    };
    return (React.createElement(PortalWrapper, null,
        React.createElement(BackgroundWrapper, { backgroundImgUrl: IMAGE_BASE_URL + "/s/managed/consumer/teams/buildings.svg" }),
        React.createElement(Container, { "data-testid": PageNotFoundTestId.PageNotFoundContainer },
            React.createElement(Text, { tag: "h1", styles: Text.Styles.PageTitle2, textAlign: Text.TextAlignments.Center, weight: Text.Weights.Medium }, errorMessage),
            React.createElement(ImgContainer, { src: IMAGE_BASE_URL + "/s/managed/consumer/teams/donut-shop.gif", title: "Donut shop with 404", alt: "Donut shop page not found" }),
            React.createElement(Button, { onClick: handleClick }, "Go Back"))));
};
export default PageNotFound;
var templateObject_1, templateObject_2;
